import React from 'react';
import { LinkText, Typography } from "../ecosystem";

const DashboardSectionHeading = ({
    disabled,
    heading,
    isMobile,
    onClick,
    sideLink,
    mBottom,
    mTop
}) => {

    const mB = mBottom ? `spacing-mBottom--${mBottom}` : '';
    const mT = mTop ? `spacing-mTop--${mTop}` : '';

    return (<div className={`dashboard-section-heading-container ${mB} ${mT}`}>
        <div onClick={onClick} className="dashboard-section-heading__title">
            <Typography
                type={isMobile ? "heading-03" : "heading-05"}
                bold={isMobile ? true : false }
            >
                {heading}
            </Typography>
        </div>
        {sideLink &&
            <div className="dashboard-section-heading__link">
                <LinkText
                    disabled={disabled}
                    to={{ pathname: sideLink.url }}
                    onClick={sideLink.onClick}
                    typographyType="body-02"
                >
                    {sideLink.label}
                </LinkText>
            </div>
        }
    </div>);
}

export default DashboardSectionHeading;
